import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { MemberBackend } from "src/app/backend/api/member.backend";
import { MemberLight } from "src/app/backend/models/member/member";
import { ColorService } from "src/app/services/color.service";

@Injectable()
export class ProvideColorsGuard {
  private readonly memberBacked = inject(MemberBackend);
  private readonly colorService = inject(ColorService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const members: MemberLight[] = await lastValueFrom(
      this.memberBacked.listActiveAllLight()
    );

    for (const member of members) {
      if (member.color) {
        this.colorService.register(member.id, member.color);
      }
    }

    return true;
  }
}
